import { Icon } from './Icon';
import { EMPTY_FILTERS, type ReportFilters } from '../types';

const SENT_LABELS: Record<string, string> = {
  unsent: 'Unsent',
  sent: 'Sent',
  sent_changed: 'Sent — changed',
};

interface Chip {
  key: keyof ReportFilters;
  label: string;
  val: string;
  /** Pretty display when the stored value is an enum (e.g. sent_changed). */
  display?: string;
}

interface Props {
  filters: ReportFilters;
  setFilters(f: ReportFilters): void;
}

export function FilterChips({ filters, setFilters }: Props): JSX.Element | null {
  const chips: Chip[] = [];
  filters.account.forEach((v) => chips.push({ key: 'account', label: 'Account', val: v }));
  filters.affiliate.forEach((v) => chips.push({ key: 'affiliate', label: 'Affiliate', val: v }));
  filters.status.forEach((v) => chips.push({ key: 'status', label: 'Status', val: v }));
  filters.sent.forEach((v) => chips.push({ key: 'sent', label: 'Sent', val: v, display: SENT_LABELS[v] ?? v }));
  if (filters.coachee) chips.push({ key: 'coachee', label: 'Coachee', val: filters.coachee });
  if (filters.opp) chips.push({ key: 'opp', label: 'Opp #', val: filters.opp });

  if (chips.length === 0) return null;

  const remove = (c: Chip) => {
    const f = { ...filters };
    const v = f[c.key];
    if (Array.isArray(v)) {
      (f[c.key] as string[]) = v.filter((x) => x !== c.val);
    } else {
      (f[c.key] as string) = '';
    }
    setFilters(f);
  };

  return (
    <div className="fchips">
      <span className="d-meta" style={{ fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', fontWeight: 600 }}>Filters</span>
      {chips.map((c, i) => (
        <span className="fchip" key={i}>
          <span style={{ color: 'var(--mute)' }}>{c.label}:</span> <strong>{c.display ?? c.val}</strong>
          <span className="x" onClick={() => remove(c)}><Icon name="x" size={12} /></span>
        </span>
      ))}
      <a className="btn-link" style={{ marginLeft: 4, fontSize: 12 }} onClick={() => setFilters(EMPTY_FILTERS)}>Clear all</a>
    </div>
  );
}
